import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  // region Atributos
  date: Date = new Date();
  // endregion

  // region Constructor
  constructor() { }
  // endregion

  // region Métodos
  ngOnInit() {
  }
  // endregion

}
